import { keyBy } from "lodash";

import {
  CRUDAction,
  IEntityDeleteSuccess,
  IEntityFetchCollectionSuccess,
  IEntityFetchSuccess,
  RequestAction,
} from "store/entities/actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "store/entities/reducer";

import { EMAIL_DOMAIN, EmailDomainAction, EmailDomainActionsNames } from "./actions";
import { IEmailDomain } from "./interfaces";

const initialState = {};

export const emailDomainsReducer = (
  state: IEntityCollectionState<IEmailDomain> = initialState,
  action: EmailDomainAction
): IEntityCollectionState<IEmailDomain> => {
  switch (action.type) {
    case EMAIL_DOMAIN[CRUDAction.CREATE][RequestAction.FAILURE]: {
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { payload } = action as any;

      return { ...state, [payload.name]: payload };
    }

    case EMAIL_DOMAIN[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]:
    case EMAIL_DOMAIN[CRUDAction.CREATE][RequestAction.SUCCESS]: {
      const { value: team } = action.payload as IEntityFetchSuccess<IEmailDomain>;
      return {
        ...state,
        [team.id]: team,
      };
    }

    case EMAIL_DOMAIN[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values } = action.payload as IEntityFetchCollectionSuccess<IEmailDomain>;
      return keyBy(values, v => v.id);
    }

    case EmailDomainActionsNames.SYNC_DELETE: {
      const { id } = action.payload as IEntityDeleteSuccess;
      const newState = { ...state };
      // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
      delete newState[id];
      return newState;
    }

    default:
      return state;
  }
};
